import { render, staticRenderFns } from "./Iscriviti.vue?vue&type=template&id=7be3a850&scoped=true"
import script from "./Iscriviti.vue?vue&type=script&lang=js"
export * from "./Iscriviti.vue?vue&type=script&lang=js"
import style0 from "./Iscriviti.vue?vue&type=style&index=0&id=7be3a850&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be3a850",
  null
  
)

export default component.exports